import React from 'react';
import { FormField } from './FormField';

interface CheckboxFieldProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    tooltip?: string;
    className?: string;
}

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
    id,
    label,
    checked,
    onChange,
    disabled = false,
    tooltip,
    className = ''
}) => {
    const handleChange = () => {
        onChange(!checked);
    };

    return (
        <FormField
            label={label}
            id={id}
            tooltip={tooltip}
        >
            <div className={`form-check form-switch ${className}`}>
                <input
                    className="form-check-input"
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </div>
        </FormField>
    );
};
